import React from 'react';
import { CreateUser } from '../..';
import { USER_ROLES } from '../../../constants/constants';

export const CreateENTAdmin = (props) => (
  <CreateUser title='Add New Admin' headText='Provide information for the new Admin'
   managedRole={USER_ROLES.ENTERPRISE_ADMIN} {...props} />
);
